import { render, staticRenderFns } from "./servers.vue?vue&type=template&id=1340af71&"
import script from "./servers.vue?vue&type=script&lang=js&"
export * from "./servers.vue?vue&type=script&lang=js&"
import style0 from "./servers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports